import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { CREW_MEDIA_BUCKET, CREW_MEDIA_PREFIX } from '../crewMedia';

function useAssetUrl(source?: string) {
  const [resolved, setResolved] = useState<{ source?: string; url: string }>({ url: '' });
  const structuredAsset = !!source?.startsWith('storage://');
  let legacyPublic=false;
  if(process.env.REACT_APP_LEGACY_ASSETS_PUBLIC==='true' && source){
    try {const u=new URL(source);const expected=new URL(process.env.REACT_APP_SUPABASE_URL||'');legacyPublic=u.origin===expected.origin&&u.pathname.startsWith('/storage/v1/object/public/production-assets/');}catch{}
  }
  const privateAsset = structuredAsset || (!legacyPublic && !!source?.includes('/storage/v1/object/public/production-assets/'));
  useEffect(() => {
    if (!source || !privateAsset) return;
    let active = true;
    const resolve = async () => {
      try {
        if (structuredAsset) {
          if (!source.startsWith(CREW_MEDIA_PREFIX)) throw new Error('Unrecognised asset bucket');
          const path = source.slice(CREW_MEDIA_PREFIX.length);
          if (!path || path.includes('..') || path.includes('?') || path.includes('#')) throw new Error('Invalid asset');
          const { data, error } = await supabase.storage.from(CREW_MEDIA_BUCKET).createSignedUrl(path, 300);
          if (error || !data?.signedUrl) throw new Error('Asset unavailable');
          if (active) setResolved({ source, url: data.signedUrl });
          return;
        }
        const url = new URL(source);
        const expected = new URL(process.env.REACT_APP_SUPABASE_URL || '');
        if (url.origin !== expected.origin) throw new Error('Unrecognised asset host');
        const prefix = '/storage/v1/object/public/production-assets/';
        if (!url.pathname.startsWith(prefix)) throw new Error('Invalid asset');
        const { data, error } = await supabase.storage.from('production-assets')
          .createSignedUrl(decodeURIComponent(url.pathname.slice(prefix.length)), 300);
        if (error || !data?.signedUrl) throw new Error('Asset unavailable');
        if (active) setResolved({ source, url: data.signedUrl });
      } catch {
        if (active) setResolved({ source, url: '' });
      }
    };
    void resolve();
    const timer = window.setInterval(resolve, 240000);
    return () => { active = false; window.clearInterval(timer); };
  }, [source, privateAsset, structuredAsset]);
  return privateAsset ? (resolved.source === source ? resolved.url : '') : source;
}

export function PrivateImage(props: React.ImgHTMLAttributes<HTMLImageElement>) {
  const url = useAssetUrl(props.src);
  return url ? <img {...props} alt={props.alt || ''} src={url} /> : <span role="status">Media unavailable</span>;
}
export function PrivateVideo(props: React.VideoHTMLAttributes<HTMLVideoElement>) {
  const url = useAssetUrl(props.src);
  return url ? <video {...props} src={url} /> : <span role="status">Media unavailable</span>;
}
export function PrivateLink(props: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  const url = useAssetUrl(props.href);
  return <a {...props} href={url || undefined} aria-disabled={!url} onClick={event => {
    if (!url) { event.preventDefault(); return; }
    props.onClick?.(event);
  }}>{props.children}</a>;
}
